import contentfulGql from 'js/lib/contentfulGql';

import { entWebsiteBlockAssemblyFragment } from 'bundles/ent-website/queries/EntWebsiteBlockAssembly';

export const entWebsiteNativeFragment = contentfulGql`#graphql
  fragment EntWebsiteNative on EntWebsiteNative {
    slug
    type
    arguments
  }
`;

export const entWebsiteBlockNativeQuery = contentfulGql`#graphql
  ${entWebsiteBlockAssemblyFragment}
  ${entWebsiteNativeFragment}

  query entWebsiteBlockNative($id: String!, $preview: Boolean, $locale: String!) {
    entWebsiteBlockAssembly(id: $id, preview: $preview, locale: $locale) {
      ...EntWebsiteBlockAssembly
      reference {
        __typename
        ...EntWebsiteNative
      }
    }
  }
`;
